import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "_flexcol _gap-3",
  "data-qa": "show-results-button"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon_base_button = _resolveComponent("icon-base-button")
  const _component_empty_state = _resolveComponent("empty-state")

  return (_openBlock(), _createBlock(_component_empty_state, { title: $props.title }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default"),
        _createVNode(_component_icon_base_button, {
          icon: "chevron-right",
          "icon-position": "right",
          onClick: $options.onButtonAction
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.buttonLabel), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"])
      ])
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["title"]))
}